import { X } from 'lucide-react';

const TALLY_URL = 'https://tally.so/r/3y11q4';

export default function WaitlistModal({ onClose }) {
  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()} data-testid="waitlist-modal">
      <div className="modal-box" style={{ maxWidth: 600, padding: 0, overflow: 'hidden', height: '85vh' }}>
        <button
          className="modal-close"
          onClick={onClose}
          data-testid="waitlist-modal-close"
          style={{ position: 'absolute', top: 12, right: 12, zIndex: 10, background: 'var(--card-bg)', borderRadius: '50%', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--border)' }}
        >
          <X size={16} />
        </button>
        <iframe
          src={TALLY_URL}
          width="100%"
          height="100%"
          frameBorder="0"
          title="Bunchh Waitlist"
          style={{ border: 'none' }}
          data-testid="tally-iframe"
        />
      </div>
    </div>
  );
}
